<template>
  <div class="fixed inset-0 bg-black flex items-center justify-center z-50">
    <div class="fixed inset-0 bg-black opacity-50"></div>
    <div class="bg-white rounded-lg p-6 z-50">
      <h2 class="text-2xl font-bold mb-4">{{ title }}</h2>
      <form @submit.prevent="submitForm">
        <div class="mb-4">
          <label for="password" class="block text-gray-700">Password :</label>
          <input type="password" id="password" v-model="password" placeholder="Insert the code" class="w-full p-2 border rounded" required>
        </div>
        <button type="submit" class="w-full bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Submit</button>
      </form>
    </div>
  </div>
</template>

<script>
import { userStore } from '../stores/user';

export default {
  name: 'ModalLogin',
  emits: ['isLogin'],
  data() {
    return {
      title: "Verify It's You!",
      password: null
    };
  },
  methods: {
    submitForm() {
      const formStore = userStore();
      let submit = formStore.submitForm(this.password); // Send data to Pinia store

      if (submit) {
        this.$emit('isLogin', true);
      }else {
        alert("It's not you!");
        this.title = "It's not you! :(";
      }
    }
  },
};
</script>